<template>
  <transition :name='transition'>
    <layout-main v-if="ishome" :title="title" class="test"></layout-main>
    <layout-module v-else :title="title" class="test"></layout-module>
  </transition>
</template>
<script>
// import padHeader from "./header";
import layoutMain from "./layout-main";
import layoutModule from "./layout-module";

export default {
  components: { layoutMain, layoutModule },
  data() {
    const homes = this.$app.menus;
    return {
      homes,
      ishome: true,
    };
  },
  computed: {
    title: {
      get() {
        let obj = this.$app.menusDict[this.$route.name];
        let $route = this.$route;
        return (obj && obj.text) || $route.meta.title || this.$route.name;
      },
      set() {},
    },
    transition() {
      //改变动画的名字来改变动画的样式（一个向左滑动，一个向右滑动）
      return this.ishome ? "right" : "left";
    },
  },
  methods: {
    go({ name, children }) {
      if (children == undefined) {
        if (this.$route.name != name) this.$router.push({ name });
      } else {
        this.$router.push({ name: "core-phoneModulesNav" }); //去到手机版的菜单列表
      }
    },
    isHomeRoute(route) {
      this.ishome =
        route.name.indexOf("core-phoneModulesNav") != -1 ||
        this.$app.menus.some((p) => p.name === route.name);
    },
  },
  watch: {
    $route:{
      handler(to, from) {
      this.isHomeRoute(to);
    },
    immediate: true
    }
  },
  mounted() {
    // TODO 当初为什么要mounted后切换路由呢
    // this.isHomeRoute(this.$route);
  },
};
</script>

<style lang="scss">
@import "./pad.scss";
.test {
  position: absolute;
  width: 100%;
  height: 100%;
}
//设置两套过度的动画，通过ishome的true与false来控制所需要的动画
.right-enter {
  opacity: 1;
  transform: translateX(-100%);
}
.right-leave-to {
  opacity: 1;
  transform: translateX(100%);
}

.right-enter-active {
  transition: all 0.3s ease;
}
.right-leave-active {
  transition: all 0.4s ease;
}

.left-enter {
  opacity: 1;
  transform: translateX(100%);
}
.left-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}

.left-enter-active,
.left-leave-active {
  transition: all 0.3s ease;
}
</style>

<style scoped>
.pad-app-footer ::v-deep .ivu-dropdown-rel {
  height: 45px;
  line-height: 45px;
}
</style>
